/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics/FctParams';
import { FaLock } from 'react-icons/fa';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
export var IsBorrowCollateralized = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'GETTER',
    method: 'isBorrowCollateralized',
    description: 'Function returns the current balance of a collateral asset for a specified account in the protocol.',
    supportedContracts: cometList,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                account: new FctAddress({ isPreview: true, icon: FaLock }),
            },
        },
        output: { hasEnoughLiquidity: new FctBoolean({ innerIndex: 0, isPreview: true }) },
    }); },
});
